export default "__VITE_ASSET__b85f1ad7__"